import { Navigate, Outlet, useLocation } from 'react-router-dom'
import useDetectVersion from 'hooks/useDetectVersion'

export default function RenewalLayout() {
  const { pathname } = useLocation()
  const { isVersionAccessable } = useDetectVersion()

  if (
    isVersionAccessable &&
    !isVersionAccessable.includes('rn') &&
    !pathname.includes('version-notfound')
  ) {
    return <Navigate to="/rn/version-notfound" replace />
  }

  return (
    <div className="rn-theme">
      <Outlet />
    </div>
  )
}
